<template>
  <div>
    <!-- 分账商户管理 -->
    <a-card title="分账商户管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>商户编号</span>
          <a-input v-model.trim="paramsData.merchantNo" placeholder="请输入商户编号" allow-clear/>
        </div>
        <div class="item">
          <span>商户名称</span>
          <a-input v-model.trim="paramsData.merchantName" placeholder="请输入商户名称" allow-clear/>
        </div>
<!--        <div class="item">-->
<!--          <span>收单机构</span>-->
<!--          <a-select v-model.trim="paramsData.acquirerOrgCode" placeholder="请选择收单机构" allow-clear>-->
<!--            <a-select-option-->
<!--                v-for="org in orgList"-->
<!--                :key="org.acquirerOrgCode"-->
<!--                :value="org.acquirerOrgCode"-->
<!--            >-->
<!--              {{ org.acquirerOrgName }}-->
<!--            </a-select-option>-->
<!--          </a-select>-->
<!--        </div>-->
        <div class="item">
          <span>状态</span>
          <a-select v-model.trim="paramsData.status" placeholder="请选择状态" allow-clear>
            <a-select-option value="1">启用</a-select-option>
            <a-select-option value="0">停用</a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>商户类型</span>
          <a-select v-model.trim="paramsData.merchantRelations" placeholder="请选择商户类型" allow-clear>
            <a-select-option value="1">主商户</a-select-option>
            <a-select-option value="2">分账商户</a-select-option>
          </a-select>
        </div>

        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="merchantAddBtn" v-if="$authority('merchantAdd')">新增商户</a-button>
          <a-button type="primary" @click="subMerchantAddBtn" v-if="$authority('subMerchantAdd')">新增分商户</a-button>
          <a-button type="primary" @click="handleQuery" v-if="$authority('merchantRefresh')">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.merchantNo"
          >
            <template slot="status" slot-scope="text">
              <a-badge :status="text === '1' ? 'success' : 'error'"/>
              {{ text === '1' ? '启用' : '停用' }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button
                    icon="eye"
                    style="color: #1890ff;"
                    type="link"
                    @click="viewBtn(record)"
                    v-if="$authority('merchantView')"
                >
                  查看
                </a-button>
                <a-button
                    icon="edit"
                    style="color: #52c41a;"
                    type="link"
                    @click="editBtn(record)"
                    v-if="$authority('merchantEdit')"
                >
                  编辑
                </a-button>
                <a-button
                    icon="redo"
                    style="color: #1890ff;"
                    type="link"
                    @click="syncBtn(record)"
                    v-if="record.merchantRelations === '1' && $authority('syncMerchant')"
                >
                  来账同步
                </a-button>
                <a-button
                    icon="delete"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="deleteBtn(record)"
                    v-if="$authority('merchantDel')"
                >
                  删除
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"
                        :fn="getTableData"/>
      </div>
    </a-card>

    <!-- 新增/编辑商户弹窗 -->
    <a-modal
        v-model="merchantFormVisible"
        :title="formType === 'add' ? (isSubMerchant ? '新增分商户' : '新增商户') : '编辑商户'"
        @ok="handleSaveMerchant"
        @cancel="handleCancelForm"
        :confirm-loading="confirmLoading"
        width="600px"
        :destroyOnClose="true"
    >
      <a-form-model
          ref="merchantForm"
          :model="formData"
          :rules="formRules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          :colon="false"
          label-align="left"
      >
        <!-- 商户基本信息 -->
        <a-form-model-item label="商户编号" prop="merchantNo">
          <a-input
              v-model.trim="formData.merchantNo"
              placeholder="请输入商户编号"
              :disabled="formType === 'edit'"
              allow-clear
          />
        </a-form-model-item>



        <a-form-model-item label="商户户名" prop="merchantName">
          <a-input
              v-model.trim="formData.merchantName"
              placeholder="请输入商户户名"
              allow-clear
          />
        </a-form-model-item>


        <a-form-model-item label="商户类型" prop="merchantRelations" v-if="!isSubMerchant">
          <a-radio-group v-model="formData.merchantRelations" :disabled="isSubMerchant">
            <a-radio value="1">主商户</a-radio>
            <a-radio value="2">分账商户</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="收单机构" prop="acqOrgs">
          <a-select
              mode="multiple"
              v-model="formData.acqOrgs"
              placeholder="请选择收单机构"
              @change="handleOrgChange"
              allow-clear
          >
            <a-select-option
                v-for="org in orgList"
                :key="org.acquirerOrgCode"
                :value="org.acquirerOrgCode"
            >
              {{ org.acquirerOrgName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="商户A1钱包" prop="accountNo">
          <WalletChooseDialog
              v-model="formData.accountName"
              :account-class="'0'"
              :open-account-class="true"
              @chooseDone="onMerchantWalletChosen"
          >
          </WalletChooseDialog>
          <div v-if="formData.accountName" style="margin-top: 8px;">
            <WalletInfo
                :account-name="formData.accountName"
                :account-no="formData.accountNo"
            />
          </div>
        </a-form-model-item>

        <a-form-model-item label="待清算账号" prop="settleAccountNo">
          <WalletChooseDialog
              v-model="formData.settleAccountName"
              :account-class="'0'"
              :open-account-class="true"
              @chooseDone="onMerchantSettleWalletChosen"
          >
          </WalletChooseDialog>
          <div v-if="formData.settleAccountName" style="margin-top: 8px;">
            <WalletInfo
                :account-name="formData.settleAccountName"
                :account-no="formData.settleAccountNo"
            />
          </div>
        </a-form-model-item>

        <a-form-model-item label="服务费收款钱包" v-if="!isSubMerchant">
          <WalletChooseDialog
              v-model="formData.feeAccountName"
              :account-class="'0'"
              :open-account-class="true"
              @chooseDone="onMerchantSettleWalletChosen2"
          >
          </WalletChooseDialog>
          <div v-if="formData.feeAccountName" style="margin-top: 8px;">
            <WalletInfo
                :account-name="formData.feeAccountName"
                :account-no="formData.feeAccountNo"
            />
          </div>
        </a-form-model-item>

        <a-form-model-item label="服务费比例" prop="feeRatio" v-if="!isSubMerchant">
          <a-input-number
              v-model="formData.feeRatio"
              :min="0"
              :max="100"
              :step="0.01"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              @change="onChange"
          />
        </a-form-model-item>

        <a-form-model-item label="清分方式" prop="settleMethod">
          <a-select v-model="formData.settleMethod" placeholder="请选择清分方式">
            <a-select-option value="TM">来账容差匹配</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="是否自动提现" prop="autoWithdraw">
          <a-radio-group v-model="formData.autoWithdraw" :default-value="0">
            <a-radio :value="0">是</a-radio>
            <a-radio :value="1">否</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 状态（编辑时显示） -->
        <a-form-model-item label="状态" prop="status" v-if="formType === 'edit'">
          <a-select v-model="formData.status" placeholder="请选择状态">
            <a-select-option value="1">启用</a-select-option>
            <a-select-option value="0">停用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 查看商户详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        title="商户详情"
        @cancel="viewModalVisible = false"
        width="900px"
        :footer="null"
        :destroyOnClose="true"
    >
      <div v-if="viewData" class="merchant-detail">
        <!-- 基本信息区域 -->
        <a-card title="基本信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="商户编号" :span="2">
              <span class="detail-value">{{ viewData.merchantNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户户名">
              <span class="detail-value">{{ viewData.merchantName }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="清分方式">
              <a-tag color="purple">
                {{ getSettleMethodText(viewData.settleMethod) }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="服务费比例">
              <span class="detail-value">{{ viewData.feeRatio }}%</span>
            </a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-badge :status="viewData.status === '1' ? 'success' : 'error'"/>
              <span :class="viewData.status === '1' ? 'status-enabled' : 'status-disabled'">
                {{ viewData.status === '1' ? '启用' : '停用' }}
              </span>
            </a-descriptions-item>
            <a-descriptions-item label="是否自动提现">
              <a-badge :status="viewData.autoWithdraw === 0 ? 'success' : 'error'"/>
              <span :class="viewData.autoWithdraw === 0 ? 'status-enabled' : 'status-disabled'">
                {{ viewData.autoWithdraw === 0 ? '是' : '否' }}
              </span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

      

        <!-- 账户信息 -->
        <a-card title="账户信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="1" size="small">
            <a-descriptions-item label="商户钱包账号">
              <WalletInfo
                  :account-name="viewData.accountName"
                  :account-no="viewData.accountNo"
                  :show-account-name="true"
              />
            </a-descriptions-item>
            <a-descriptions-item label="清算账号">
              <WalletInfo
                  :account-name="viewData.settleAccountName"
                  :account-no="viewData.settleAccountNo"
                  :show-account-name="true"
              />
            </a-descriptions-item>
            <a-descriptions-item label="服务费收款钱包">
              <WalletInfo
                  :account-name="viewData.feeAccountName"
                  :account-no="viewData.feeAccountNo"
                  :show-account-name="true"
              />
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
<!--        &lt;!&ndash; 收单机构信息 &ndash;&gt;-->
<!--        <a-card title="收单机构信息" size="small" :bordered="false" class="detail-section">-->
<!--          <a-descriptions bordered :column="1" size="small">-->
<!--            <a-descriptions-item label="收单机构列表">-->
<!--              <div v-for="orgAccount in viewData.acqOrgAccList" :key="orgAccount.acquirerOrgCode" class="org-account-item">-->
<!--                <div><span class="label">编号:</span> {{ orgAccount.acquirerOrgCode }}</div>-->
<!--                <div><span class="label">名称:</span> {{ orgAccount.acquirerOrgName }}</div>-->
<!--              </div>-->
<!--            </a-descriptions-item>-->
<!--          </a-descriptions>-->
<!--        </a-card>-->
<!--        -->
        <!-- 收单机构账户列表 -->
        <a-card v-if="viewData?.acqOrgAccList && viewData?.acqOrgAccList.length > 0" title="收单机构账户" size="small" :bordered="false" class="detail-section">
          <a-list
              :data-source="viewData.acqOrgAccList"
              :grid="{ gutter: 16, column: 2 }"
              size="small"
          >
            <a-list-item slot="renderItem" slot-scope="item" class="org-account-item">
              <a-card
                  size="small"
                  :bordered="true"
                  class="org-account-card"
                  :body-style="{ padding: '12px' }"
              >
                <div class="org-account-header">
                  <a-icon type="bank" style="color: #1890ff; margin-right: 8px;"/>
                  <strong class="account-name">{{ item.accountName }}</strong>
                </div>
                <div class="org-account-content">
                  <div class="account-info">
                    <span class="info-label">账户号：</span>
                    <span class="info-value">{{ item?.accountNo }}</span>
                  </div>
                  <div class="account-info">
                    <span class="info-label">机构编号：</span>
                    <span class="info-value">{{ item.acquirerOrgCode }}</span>
                  </div>
                  <div class="account-info">
                    <span class="info-label">机构名称：</span>
                    <span class="info-value">{{ item.acquirerOrgName }}</span>
                  </div>
                </div>
              </a-card>
            </a-list-item>
          </a-list>
        </a-card>

        <!-- 系统信息 -->
        <a-card title="系统信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="创建时间">
              <span class="detail-value">{{ formatDateTime(viewData.createTime) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="创建人">
              <span class="detail-value">{{ viewData.creater || '-' }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="更新时间">
              <span class="detail-value">{{ formatDateTime(viewData.updateTime) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="更新人">
              <span class="detail-value">{{ viewData.updater || '-' }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <a-empty description="暂无商户数据"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";

export default {
  name: 'merchant',
  components: {LcfsPagination, WalletInfo, WalletChooseDialog},
  data() {
    return {
      // 表单相关
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      merchantFormVisible: false,
      formType: 'add',
      isSubMerchant: false,
      confirmLoading: false,
      formData: {
        merchantNo: "",
        merchantName: "",
        acqOrgs: [],
        acquirerOrgName: "",
        accountNo: "",
        accountName: "",
        settleAccountNo: "",
        settleAccountName: "",
        feeAccountNo: "",
        feeAccountName: "",
        feeRatio: "",
        merchantRelations: "1",
        settleMethod: "TM",
        status: "1",
        autoWithdraw: 0
      },
      formRules: {
        merchantNo: [
          {required: true, message: '请输入商户编号', trigger: 'blur'},
        ],
        merchantName: [
          {required: true, message: '请输入商户户名', trigger: 'blur'},
          {min: 2, max: 128, message: '商户户名长度在2到128个字符之间', trigger: 'blur'}
        ],
        acqOrgs: [
          {required: true, message: '请选择收单机构', trigger: 'change'}
        ],
        accountNo: [
          {required: true, message: '请选择商户A1钱包', trigger: 'change'}
        ],
        settleAccountNo: [
          {required: true, message: '请选择待清算账号', trigger: 'change'}
        ],
        feeAccountNo: [
          {required: true, message: '请选择服务费收款钱包', trigger: 'change'}
        ],
        settleMethod: [
          {required: true, message: '请选择清分方式', trigger: 'change'}
        ],
        merchantRelations: [
          {required: true, message: '请选择商户类型', trigger: 'change'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      },

      // 查看详情
      viewModalVisible: false,

      viewData: null,

      // 收单机构列表
      orgList: [],

      // 表格数据
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 40
        },
        {
          title: "商户账号/户名",
          align: "center",
          width: 150,
          ellipsis: true,
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.merchantNo}
                  </div>

                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.merchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: "商户类型",
          align: "center",
          width: 80,
          ellipsis: true,
          customRender: (text, record) => {
            return (
                <a-tag color={record.merchantRelations === '1' ? 'green' : 'blue'}><span>{record.merchantRelations === '1' ? '主商户' : '分商户'}</span></a-tag>
            );
          }
        },

        {
          title: "商户钱包账号",
          dataIndex: "accountNo",
          align: "center",
          width: 120,
          ellipsis: true,
          customRender: (text, row) => {
            return <WalletInfo accountNo={text} accountName={row.accountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "清算账号",
          dataIndex: "settleAccountNo",
          align: "center",
          width: 120,
          ellipsis: true,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.settleAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "状态",
          dataIndex: "status",
          align: "center",
          width: 80,
          scopedSlots: {customRender: 'status'}
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 120,
          customRender: (text) => {
            if (!text) return "-";
            return this.formatDateTime(text);
          },
        },
        {
          title: "操作",
          key: "action",
          width: 180,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 分页相关
      paramsData: {
        merchantNo: "",
        merchantName: "",
        merchantRelations: "1",
        status: "",
      },
    };
  },
  mounted() {
    this.getTableData();
    this.getOrgList();
  },
  methods: {
    onMerchantWalletChosen(wallet) {
      this.formData.accountNo = wallet.accountNo;
      this.formData.accountName = wallet.accountName;
      // 触发校验
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('accountNo');
      });
    },

    onMerchantSettleWalletChosen(wallet) {
      this.formData.settleAccountNo = wallet.accountNo;
      this.formData.settleAccountName = wallet.accountName;
      // 触发校验
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('settleAccountNo');
      });
    },
    onMerchantSettleWalletChosen2(wallet) {
      this.formData.feeAccountNo = wallet.accountNo;
      this.formData.feeAccountName = wallet.accountName;
      // 触发校验
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('feeAccountNo');
      });
    },

    onChange(value) {
      this.formData.feeRatio = value;
    },



    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    // 获取收单机构列表
    async getOrgList() {
      try {
        const res = await this.api.acquirerAccountOrgListApi();
        if (res.code === 200) {
          this.orgList = res.data || [];
        } else {
          message.warning(res.info || "获取收单机构列表失败");
        }
      } catch (error) {
        console.error("获取收单机构列表失败:", error);
        message.error("获取收单机构列表失败");
      }
    },

    // 收单机构选择变化
    handleOrgChange(value) {
      console.log("handleOrgChange :",value)
    },

    // 获取表格数据
    async getTableData() {
      try {
        const res = await this.api.settleMerchantPageApi({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,  // 明确使用 pagination 的值
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        pageNo: 1,
        pageSize: 20,
        merchantNo: "",
        merchantName: "",
        status: "",
      };
      this.getTableData();
    },

    // 新增商户
    merchantAddBtn() {
      this.formType = 'add';
      this.isSubMerchant = false;
      this.merchantFormVisible = true;
      this.$nextTick(() => {
        this.resetForm();
      });
    },

    // 新增分商户
    subMerchantAddBtn() {
      this.formType = 'add';
      this.isSubMerchant = true;
      this.merchantFormVisible = true;
      this.$nextTick(() => {
        this.resetForm();
        this.formData.merchantRelations = '2';
      });
    },

    // 编辑商户
    async editBtn(record) {
      try {
        const res = await this.api.settleMerchantDetailApi(record.merchantNo);
        if (res.code === 200 && res.data) {
          this.formType = 'edit';
          this.formData = {...res.data};
          if (this.formData.feeRatio > 0) {
            this.formData.feeRatio = this.formData.feeRatio * 100;
          }
          this.merchantFormVisible = true;
        } else {
          message.warning(res.info || "获取商户信息失败");
        }
      } catch (error) {
        console.error("获取商户信息失败:", error);
        message.error("获取商户信息失败");
      }
    },

    async syncBtn(record) {

        const res = await this.api.synchTranItemApi({
          "merchantNo": record.merchantNo,
          "day": 3
        });

        if (res.code === 200) {
          message.success("同步成功");
        } else {
          message.warning(res.info || "同步失败");
        }


    },

    // 获取清分方式文本
    getSettleMethodText(method) {
      const methodMap = {
        'TM': '来账容差匹配',
      };
      return methodMap[method] || method;
    },

    // 查看详情
    async viewBtn(record) {
      try {
        const res = await this.api.settleMerchantDetailApi(record.merchantNo);
        if (res.code === 200 && res.data) {
          this.viewData = res.data;
          if (this.viewData.feeRatio > 0) {
            this.viewData.feeRatio = this.viewData.feeRatio * 100;
          }
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取商户详情失败");
        }
      } catch (error) {
        console.error("获取商户详情失败:", error);
        message.error("获取商户详情失败");
      }
    },

    // 重置表单
    resetForm() {
      this.formData = {
        merchantNo: "",
        merchantName: "",
        acqOrgs: [],
        acquirerOrgName: "",
        accountNo: "",
        accountName: "",
        settleAccountNo: "",
        settleAccountName: "",
        feeAccountNo: "",
        feeAccountName: "",
        feeRatio: 0,
        merchantRelations: "1",
        settleMethod: "TM",
        status: "1",
        autoWithdraw: 0
      };
      this.$refs.merchantForm && this.$refs.merchantForm.resetFields();
    },

    // 保存商户
    async handleSaveMerchant() {
      this.$refs.merchantForm.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            let res;

            if (this.formData.feeRatio > 0) {
              this.formData.feeRatio = this.formData.feeRatio / 100;
            }
            console.log("保存商户:", this.formData);
            if (this.formType === 'add') {
              res = await this.api.settleMerchantSaveApi(this.formData);
            } else {
              res = await this.api.settleMerchantEditApi(this.formData);
            }

            if (res.code === 200) {
              message.success(this.formType === 'add' ? '新增成功' : '编辑成功');
              this.merchantFormVisible = false;
              this.getTableData();
            } else {
              message.error(res.info || (this.formType === 'add' ? '新增失败' : '编辑失败'));
            }
          } catch (error) {
            console.error("保存失败:", error);
            message.error(this.formType === 'add' ? '新增失败' : '编辑失败');
          } finally {
            this.confirmLoading = false;
          }
        } else {
          message.error('请填写完整信息');
        }
      });
    },

    // 取消表单
    handleCancelForm() {
      this.merchantFormVisible = false;
      this.resetForm();
    },

    // 删除商户
    deleteBtn(record) {
      this.$confirm({
        title: `确认删除商户 [${record.merchantName}] 吗？`,
        content: '删除后无法恢复，请谨慎操作。',
        okText: '确认删除',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
          try {
            const res = await this.api.settleMerchantDelApi(record.merchantNo);
            if (res.code === 200 && res.data) {
              message.success("删除成功");
              this.getTableData();
            } else {
              message.warning(res.info || "删除失败");
            }
          } catch (error) {
            console.error("删除失败:", error);
            message.error("删除失败");
          }
        },
        onCancel() {
          console.log("取消删除");
        },
      });
    },


  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.merchant-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }

  .status-enabled {
    color: #52c41a;
    font-weight: 500;
  }

  .status-disabled {
    color: #ff4d4f;
    font-weight: 500;
  }

  .org-account-item {
    padding: 0;

    .org-account-card {
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        border-color: #1890ff;
      }

      .org-account-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;

        .account-name {
          color: #1890ff;
          font-size: 14px;
        }
      }

      .org-account-content {
        .account-info {
          display: flex;
          margin-bottom: 4px;

          &:last-child {
            margin-bottom: 0;
          }

          .info-label {
            color: #666;
            min-width: 60px;
            font-size: 12px;
          }

          .info-value {
            color: #333;
            font-size: 12px;
            font-weight: 500;
          }
        }
      }
    }
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}

@media (max-width: 768px) {
  .merchant-detail {
    .detail-section {
      /deep/ .ant-descriptions-bordered .ant-descriptions-item {
        padding: 8px 12px;
      }
    }
  }
}

/deep/ .ant-descriptions-item-label {
  font-weight: bold;
  background-color: #fafafa;
}

.org-account-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.org-account-item:last-child {
  border-bottom: none;
}
.label {
  font-weight: bold;
  color: #666;
  margin-right: 8px;
}
</style>